// extracted by mini-css-extract-plugin
export var button = "SidebarGroup-module--button--Wzcz1";
export var expandButton = "SidebarGroup-module--expandButton--41zWd";
export var expanded = "SidebarGroup-module--expanded--8ujtz";
export var label = "SidebarGroup-module--label--qsDl4";
export var noLabel = "SidebarGroup-module--noLabel--+z+Kh";
export var root = "SidebarGroup-module--root--gK-C9";
export var secondaryLabel = "SidebarGroup-module--secondaryLabel--aqMO2";
export var secondaryWrapper = "SidebarGroup-module--secondaryWrapper--qPYYa";